// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"876944a7","37":"65336493","210":"18dff472","423":"b901009d","551":"89c6f273"}[chunkId] + ".chunk.js";
};